module.exports = __webpack_public_path__ + "static/media/image_56.3597a18d.png";